/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.BidderQuestionTemplates = {
  _resetTemplateEditor(event) {
    event.preventDefault();
    $("#bidder_questions_table input[type='checkbox']").prop('checked', false);
    $("#included_all_questions, #required_all_questions").prop('checked', false);

    $('.category-select').attr('required', false);
    $("#bidder_questions_table input[type!='submit'][name!='authenticity_token']").val('');
    return $("#bidder_questions_table select").not("#bidder_question_templates").prop('selectedIndex', 0);
  },

  _selectAllQuestions(event) {
    return _.each(['included', 'required'], function(columnName) {
      const $questions = $(`input[data-${columnName}='true']`);
      const questionsChecked = _.map($questions, question => $(question).prop('checked'));
      return $(`#${columnName}_all_questions`).prop('checked', _.every(questionsChecked, questionChecked => questionChecked));
    });
  },

  _selectIncludeInForm(event) {
    const $target = $(event.currentTarget);
    if ($target.prop('checked')) {
      $target.closest('td').prev().find('input[type="checkbox"]').prop('checked', true);
      $target.closest('td').prev().prev().find('select').attr('required', true);
    }
    return this._selectAllQuestions();
  },

  _selectRequireInForm(event) {
    const $target = $(event.currentTarget);
    if (!$target.prop('checked')) {
      $target.closest('td').next().find('input[type="checkbox"]').prop('checked', false);
      $target.closest('td').prev().find('select').removeAttr('required');
    } else {
      $target.closest('td').prev().find('select').attr('required', true);
    }

    return this._selectAllQuestions();
  },

  _includeAllQuestions(event) {
    const $target = $(event.currentTarget);
    const checked = $target.prop('checked');
    $('input[data-included="true"]').prop('checked', checked);
    return this._requireCategoryFields();
  },

  _requireAllQuestions(event) {
    const $target = $(event.currentTarget);
    const checked = $target.prop('checked');
    $('input[data-required="true"]').prop('checked', checked);

    if (checked) {
      $('input[data-included="true"]').prop('checked', checked);
      this._selectAllQuestions();
    }

    return this._requireCategoryFields();
  },

  _requireCategoryFields() {
    return _.each($('#form_of_tenders_issuer_form, .edit_bidder_question_template').find('tr.fields'), function(row) {
      const $row = $(row);
      const res = ($row.find('.included-box').prop('checked') || $row.find('.required-box').prop('checked'));
      return $row.find('.category-select').attr('required', res);
    });
  },

  initializeTemplateEditor() {
    $(document).on('click', 'input[data-required="true"]', _.bind(this._selectIncludeInForm, this));
    $(document).on('click', 'input[data-included="true"]', _.bind(this._selectRequireInForm, this));
    $(document).on('click', '#form_of_tenders_reset_button', _.bind(this._resetTemplateEditor, this));
    $(document).on('click', '#included_all_questions', _.bind(this._includeAllQuestions, this));
    $(document).on('click', '#required_all_questions', _.bind(this._requireAllQuestions, this));
    return this._selectAllQuestions();
  }
};
